import { Button, Flex, Typography } from "antd";
import React from "react";

const { Paragraph, Text } = Typography;

export default function PeriodSelector({
  selectedPeriod,
  setSelectedPeriod,
  startDate,
  endDate,
}) {
  const formatMessage = (startDate, endDate) => {
    if (selectedPeriod === "yesterday") {
      return ` ${new Date(startDate).toLocaleString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })}`;
    } else {
      return `${new Date(startDate)
        .toLocaleString("pt-BR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: selectedPeriod === "day" ? "2-digit" : undefined,
          minute: selectedPeriod === "day" ? "2-digit" : undefined,
          hour12: false,
        })
        .replace("T", ",")} até ${new Date(endDate)
        .toLocaleString("pt-BR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: selectedPeriod === "day" ? "2-digit" : undefined,
          minute: selectedPeriod === "day" ? "2-digit" : undefined,
          hour12: false,
        })
        .replace("T", ",")}`;
    }
  };
  return (
    <Flex
      justify="space-between"
      style={{
        backgroundColor: "#d0d6e2",
        padding: "1rem 1rem",
        borderRadius: 10,
      }}>
      <Flex
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 8,
        }}>
        <Paragraph style={{ marginBottom: 0, fontWeight: 500, fontSize: 18 }}>
          Período de análise:
        </Paragraph>
        <Text style={{ fontSize: 18 }}>
          {formatMessage(startDate, endDate)}
        </Text>
      </Flex>

      <Flex style={{ alignItems: "center", gap: 8 }}>
        <Button
          type={selectedPeriod === "day" ? "primary" : "default"}
          onClick={() => setSelectedPeriod("day")}>
          Hoje
        </Button>
        <Button
          type={selectedPeriod === "yesterday" ? "primary" : "default"}
          onClick={() => setSelectedPeriod("yesterday")}>
          Último dia com dados de permanência
        </Button>
        <Button
          type={selectedPeriod === "week" ? "primary" : "default"}
          onClick={() => setSelectedPeriod("week")}>
          Últimos 7 dias
        </Button>
        <Button
          type={selectedPeriod === "month" ? "primary" : "default"}
          onClick={() => setSelectedPeriod("month")}>
          Últimos 30 dias
        </Button>
      </Flex>
    </Flex>
  );
}
